import axios from 'axios';
import i18next from 'i18next';
import XLSX from 'xlsx';

export const downloadXlsx = async ({path, localePath}: {path: string; localePath: string}) => {
    const buffer = await axios.get<ArrayBuffer>(path, {responseType: 'arraybuffer'});
    const workbook = XLSX.read(buffer.data, {
        cellStyles: true,
        cellText: true,
        cellNF: true,
        type: 'buffer',
    });

    const oldWorksheetName = workbook.SheetNames.pop();
    if (!oldWorksheetName) return;
    const worksheet = workbook.Sheets[oldWorksheetName];
    delete workbook.Sheets[oldWorksheetName];

    const getCell = (index: number): XLSX.CellObject =>
        worksheet[XLSX.utils.encode_cell({c: index, r: 0})];

    let currentIndex = 0;
    let currentCell = getCell(0);
    while (currentCell) {
        const oldValue = currentCell.v;
        if (oldValue) {
            const key = localePath + '.' + oldValue;
            if (i18next.exists(key)) {
                currentCell.v = i18next.t(key) as string;
            }
        }
        currentCell = getCell(currentIndex);
        currentIndex++;
    }

    const newWorksheetName = i18next.exists('examples.first-list')
        ? i18next.t('examples.first-list')
        : oldWorksheetName;
    workbook.SheetNames.push(newWorksheetName);
    workbook.Sheets[newWorksheetName] = worksheet;

    XLSX.writeFile(workbook, i18next.t(localePath + '.filename') + '.xlsx', {
        cellStyles: true,
        compression: true,
    });
};
